//      
                                                                

              
                                
                  
   

export default function getIsDisplaced({ displaced, id }      )          {
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-is-displaced.js